
import { Row, Col, Button } from 'antd'

import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'

import '../confirmDialog.css'
import './CompareDialog.css'

function DeleteConfirmationDialog({ title, show, handleCancel, project, handleClickOK }) {

    return (
        <>
            <Modal className='centered-title-modal' show={show} onHide={handleCancel} centered>
                <Modal.Header closeButton style={{ fontSize: 16, display: 'block' }}>
                    {title}
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col span={24} className='space-btm'>
                            <div className='' >
                                <Row>
                                    <Col span={12}>Station Name:</Col>
                                    <Col span={12}>{project.stationName}</Col>
                                </Row>
                            </div>
                            <div className='spacing-section'>
                                <Row>
                                    <Col span={12}>BPID:</Col>
                                    <Col span={12}>{project.bpid}</Col>
                                </Row>
                                
                                <Row>
                                    <Col span={12}>Work Order:</Col>
                                    <Col span={12}>{project.workOrder}</Col>
                                </Row>
                            </div>
                            <div className='spacing-section' >
                                <Row>
                                    <Col span={12}>Construction Start Date:</Col>
                                    <Col span={12}>{project.constructionStartDate}</Col>
                                </Row>
                                <Row>
                                    <Col span={12}>In-Service Date:</Col>
                                    <Col span={12}>{project.inServiceDate}</Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <div className="footer-centered-content">
                    <Button type='primary' id="cancelButton" onClick={() => handleClickOK(project)}>Yes</Button>
                    <Button type='primary' id="cancelButton" onClick={handleCancel}>Cancel</Button>
                </div>
            </Modal>
        </>
    )
}

export default DeleteConfirmationDialog;            